import AuthGuard from "auth/AuthGuard";
import SessionGuard from "auth/SessionGuard";
import PublicGuard from "auth/PublicGuard";

import VenueLogLayout from "components/VenueLogLayout/VenueLogLayout";

import sessionRoutes from "routes/session-routes";
import Redirect from "pages/redirect/Redirect";
import privateRoutes from "./private-routes";
import publicRoutes from "routes/public-routes";

const routes = [
  // {
  //   element: (
  //     <AuthGuard >
  //       <MatxLayout />
  //     </AuthGuard>
  //   ),
  //   children: [...privateRoutes ]
  // },

  {
    element: (
      <AuthGuard >
        <VenueLogLayout />
      </AuthGuard>
    ),
    children: [...privateRoutes ]
  },



  // // public pages route


  {
    element: (
      <PublicGuard >
       
      </PublicGuard>
    ),
    children: [  ...publicRoutes , ]
  },


  {
    element: (
      <SessionGuard >
       
      </SessionGuard>
    ),
    children: [...sessionRoutes ]
  },


  { path: "/", element: <Redirect /> },

];

export default routes;
